import { Box, Typography, Avatar, Card, CardContent, Stack, Divider, Tooltip } from '@mui/material';
import { ImageOutlined as ImageOutlinedIcon, ArrowForwardOutlined as ArrowIcon } from '@mui/icons-material';
import Badge from './Badge';
import Button from './Button';

// Deliberately creator-only: this mini card renders on the Profile/Onboarding
// pages, which should only ever load the basics section. Audience and
// collaboration totals live on the full preview (`/dashboard/preview`),
// which loads everything only when a user explicitly opens it.
function ProfilePreview({ creator }) {
  return (
    <Card sx={{ borderRadius: 3, boxShadow: '0 1px 3px rgba(20, 10, 50, 0.06)', overflow: 'hidden' }}>
      <Box sx={{ position: 'relative' }}>
        {creator.coverUrl ? (
          <Box component="img" src={creator.coverUrl} alt="" sx={{ width: '100%', height: 96, objectFit: 'cover', display: 'block' }} />
        ) : (
          <Box sx={{ width: '100%', height: 96, bgcolor: 'grey.200', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <ImageOutlinedIcon sx={{ color: 'grey.500', fontSize: 28 }} />
          </Box>
        )}
        <Box
          sx={{
            position: 'absolute',
            top: 14,
            right: 14,
            px: 1.25,
            py: 0.4,
            borderRadius: 999,
            bgcolor: 'rgba(20, 10, 50, 0.55)',
          }}
        >
          <Typography variant="caption" sx={{ color: 'white', fontWeight: 600, letterSpacing: '0.03em' }}>
            Mini card
          </Typography>
        </Box>
      </Box>
      <CardContent sx={{ pt: 0 }}>
        <Avatar
          src={creator.avatarUrl}
          sx={{
            width: 72,
            height: 72,
            border: '3px solid white',
            boxShadow: '0 2px 8px rgba(20, 10, 50, 0.15)',
            mt: -4.5,
            mb: 1,
          }}
        />
        <Typography
          variant="h6"
          sx={{ color: creator.displayName ? 'text.primary' : 'text.disabled', fontStyle: creator.displayName ? 'normal' : 'italic' }}
        >
          {creator.displayName || 'Display name'}
        </Typography>
        <Typography
          sx={{ color: creator.username ? 'text.secondary' : 'text.disabled', fontStyle: creator.username ? 'normal' : 'italic' }}
        >
          @{creator.username || 'username'}
        </Typography>
        <Typography
          sx={{
            mt: 1,
            whiteSpace: 'pre-line',
            color: creator.headline ? 'text.primary' : 'text.disabled',
            fontStyle: creator.headline ? 'normal' : 'italic',
          }}
        >
          {creator.headline || 'Your professional headline'}
        </Typography>
        <Stack direction="row" spacing={1} useFlexGap sx={{ mt: 1.5, flexWrap: 'wrap' }}>
          {creator.niches.map((tag) => (
            <Badge key={tag}>{tag}</Badge>
          ))}
        </Stack>

        <Divider sx={{ mt: 2, mb: 2 }} />

        <Tooltip title={creator.username ? '' : 'Set a username in your profile to preview it'}>
          <span>
            <Button
              variant="secondary"
              disabled={!creator.username}
              onClick={() => window.open('/dashboard/preview', '_blank', 'noopener,noreferrer')}
              sx={{ width: '100%', justifyContent: 'space-between' }}
              endIcon={<ArrowIcon fontSize="small" />}
            >
              View full preview profile
            </Button>
          </span>
        </Tooltip>
      </CardContent>
    </Card>
  );
}

export default ProfilePreview;
